/**
 * 货品品类(Y-05)。**单点定义在这里,三端引用。**
 *
 * 食品 / 纸张文书 / 船舶证书 / 机械配件 / 日用品 / 其他。
 *
 * 它不参与计价(计价的三维是重量 × 规格 × 距离,M-02),
 * 但契约的 QuoteInput 里是必填 —— 因为下单时这一项要落进订单给监管端看(M-04)。
 * 试算阶段收下它、校验它、不拿它算钱。
 */
export const CARGO_CATEGORY = [
  'food',
  'documents',
  'ship_certificates',
  'machinery_parts',
  'daily_goods',
  'other',
] as const

export type CargoCategory = (typeof CARGO_CATEGORY)[number]

export function isCargoCategory(x: unknown): x is CargoCategory {
  return typeof x === 'string' && (CARGO_CATEGORY as readonly string[]).includes(x)
}
